import { Text } from '@dixa/lib-shared-habla';
import { ConversationAutomationTagLogEntry } from 'lib-shared-types-api';

type RoutedThroughTagProps = {
  node: ConversationAutomationTagLogEntry;
};

export function RoutedThroughTag({ node }: RoutedThroughTagProps): JSX.Element {
  /**
   * TODO: Fetch array of human readable tag names and display them. But do this
   * when an api is available. See
   * https://dixa-product.atlassian.net/browse/AX-1147
   */
  const { added_tag_ids: addedTagIds, removed_tag_ids: removedTagIds } = node;

  const addedTagsText =
    addedTagIds.length > 0
      ? `${addedTagIds.length} tag${addedTagIds.length > 1 ? 's' : ''} added`
      : false;
  const removedTagsText =
    removedTagIds.length > 0
      ? `${removedTagIds.length} tag${
          removedTagIds.length > 1 ? 's' : ''
        } removed`
      : false;

  const tagText = [addedTagsText, removedTagsText]
    .filter(Boolean)
    .join(' and ');

  return <Text.Paragraph>Tag · {tagText}</Text.Paragraph>;
}
